import H from "history";
import { MessageBarType } from "office-ui-fabric-react";
import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import School from "../../../models/School";
import {SchoolWorkloadConfig} from "../../../models/SchoolWorkloadConfig";
import SdsSubject from "../../../models/SdsSubject";
import Actions from "../../../redux/Actions";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import ApiService from "../../ApiService";
import SyncSubjectsAndYearsPrompt from "../../SyncSubjectsAndYearsPrompt";
import OnboardNavigation from "../onboard/OnboardNavigation";
import OnboardTimeline, {OnboardTimelineItem} from "../onboard/OnboardTimeline";
import {SubjectMerge} from "../../../models/SubjectMerge";
import HelpBox from "../admin/HelpBox";
import SubjectRenameEditor from "../../SubjectRenameEditor";

interface OnboardSubjectRenamePageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
    history: H.History;
}

interface OnboardSubjectRenamePageState {
    school?: School;
    schoolWorkloadConfig?: SchoolWorkloadConfig;
    subjectMerges?: SubjectMerge[];
    sdsSubjects: SdsSubject[];
}

class OnboardSubjectRenamePage extends Component<OnboardSubjectRenamePageProps & DispatchProps, OnboardSubjectRenamePageState> {
    static displayName = OnboardSubjectRenamePage.name;

    constructor(props: OnboardSubjectRenamePageProps & DispatchProps) {
        super(props);

        this.state = {
            sdsSubjects: [],
            subjectMerges: undefined,
            schoolWorkloadConfig: undefined,
        };
    }

    private saveConfig = async () => {
        if (this.state.subjectMerges === undefined) {
            return false;
        }

        
        const savedSubjectMerges = await this.props.apiService.putSubjectMergesForSchool(this.props.tenantId, this.props.schoolCode, this.state.subjectMerges);
        await this.props.dispatch(Actions.showMessageBar("Saved subject merges to config", MessageBarType.success));
        
        this.setState({
            subjectMerges: savedSubjectMerges
        });

        return true;
    }

    async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode) {
            await this.load();
        }
    }

    async componentDidUpdate(prevProps: Readonly<OnboardSubjectRenamePageProps & DispatchProps>, prevState: OnboardSubjectRenamePageState): Promise<void> {

        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.load();
        }
    }

    private async load(): Promise<void> {
        const school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode)
        const schoolWorkloadConfig = await this.props.apiService.getSchoolConfigJson(this.props.tenantId, this.props.schoolCode);
        const subjectMerges = await this.props.apiService.getSubjectMergesForSchool(this.props.tenantId, this.props.schoolCode);
        const sdsSubjects = await this.props.apiService.getSdsSubjectsForSchool(this.props.tenantId, this.props.schoolCode);

        this.setState({
            school,
            schoolWorkloadConfig,
            subjectMerges,
            sdsSubjects
        });
    }

    render() {

        let subjectRenameEditor: React.ReactElement | null = null;
        if(this.state.subjectMerges !== undefined && this.state.schoolWorkloadConfig !== undefined)
        {
            subjectRenameEditor = (
                <SubjectRenameEditor onMergesChanged={
                    (subjectMerges) => {
                        this.setState({subjectMerges: subjectMerges});
                    }}
                     sdsSubjects={this.state.sdsSubjects}
                     subjectMerges={this.state.subjectMerges}
                     subjectExcludes={this.state.schoolWorkloadConfig.subjectExcludes}
                />  
            );
        }
        
        return (
            <Fragment>

                {this.state.school ? <SyncSubjectsAndYearsPrompt school={this.state.school} message={"SyncSubjectsAndYears must have completed for unmerged subjects to appear."} /> : null}
                
                <HelpBox
                    TitleText={"Rename Subjects"}
                    HelpBoxText={"Rename subjects below"}
                    Icon={"Edit"}
                />

                <OnboardTimeline tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} apiService={this.props.apiService}>
                    {(school: School,timelineItems: OnboardTimelineItem[]) => {
                        return (
                            <Fragment>
                                {subjectRenameEditor}

                                <OnboardNavigation currentTimelineItemKey={"subject-rename"} timelineItems={timelineItems} completeItem={this.saveConfig} enableNext={true} enableSave={true} history={this.props.history} tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                            </Fragment>
                        );
                    }}
                </OnboardTimeline>                
           </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): OnboardSubjectRenamePageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            apiService: state.auth.apiService,
            history: ownProps.history,
        };
    }
)(OnboardSubjectRenamePage)